<template>
  <section class="fmhind-tab-areas">
    <NumberOfStudents class="fmhind-tab-areas__chart" />
    <NumberOfDiplomas class="fmhind-tab-areas__chart" />
    <NumberOfContEducation class="fmhind-tab-areas__chart" />
    <Titles class="fmhind-tab-areas__chart--wide" />
  </section>
</template>

<script>
import Titles from '@/components/ConcreteCharts/Titles';
import NumberOfStudents from '@/components/ConcreteCharts/NumberOfStudents';
import NumberOfDiplomas from '@/components/ConcreteCharts/NumberOfDiplomas';
import NumberOfContEducation from '@/components/ConcreteCharts/NumberOfContEducation';

export default {
  name: 'Areas',
  components: {
    Titles,
    NumberOfStudents,
    NumberOfDiplomas,
    NumberOfContEducation
  }
};
</script>

<style lang="scss">
.fmhind-tab-areas {
  display: flex;
  flex-wrap: wrap;
  @include media('<medium') {
    padding: $padding-lg;
  }
}

.fmhind-tab-areas__chart {
  @extend %chart;
  width: 33.333333%;

  &--wide {
    width: 70%;

    @include media('<medium') {
      width: 100%;
    }
  }

  @include media('<medium') {
    width: 100%;
  }
}
</style>
